export default "__VITE_ASSET__Bft2bpKt__"